import React, { useState } from 'react';
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

const ImportEpikBoxModal = ({ modal, toggle, onConfirm }) => {
  const [value, setValue] = useState('');

  return (
    <div>
      <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader toggle={toggle}>Import Edge Device</ModalHeader>
        <ModalBody>
          <span>Import Number</span>
          <Input value={value} onChange={e => setValue(e.currentTarget.value)} />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={toggle}>
            Cancel
          </Button>
          <Button color="primary" onClick={() => onConfirm(value)}>
            Import
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ImportEpikBoxModal;
